export const API_REQUESTS = {
  CHECK_IF_CREDENTIALS_VALID: "CHECK_IF_CREDENTIALS_VALID",
  CHECK_IF_SURVEY_LINKED_TO_APPLICANT_GROUP: "CHECK_IF_SURVEY_LINKED_TO_APPLICANT_GROUP",
  CREATE_APPLICANT_SESSION: "CREATE_APPLICANT_SESSION",
  CHECK_USER_ANSWERS_STATUS: "CHECK_USER_ANSWERS_STATUS",
  CREATE_NON_APPLICANT_SESSION: "CREATE_NON_APPLICANT_SESSION",

  GET_SPLASH_PAGE_BY_ROUTE: "GET_SPLASH_PAGE_BY_ROUTE",
  GET_SURVEY_BY_ID: "GET_SURVEY_BY_ID",
  CHECK_USER_ANSWERS: "CHECK_USER_ANSWERS",

  SAVE_ANSWERS: "SAVE_ANSWERS",
  FINISH_SURVEY: "FINISH_SURVEY",
};
